module.exports = __webpack_public_path__ + "static/img/down.4cd553ad.svg";